import { Component } from '@angular/core';

@Component({
  selector: 'mav-start-project-icon',
  templateUrl: './start-project-icon.component.html',
  styleUrls: ['./start-project-icon.component.scss']
})
export class StartProjectIconComponent {
  isMenuOpen = false;
}
